// extracted by mini-css-extract-plugin
export default {"modalLayout":"modal_modalLayout__t4SjR"};